import React from 'react'
import ReportHome from './ReportHome'

const Reports = () => {
    return <ReportHome />
}

export default Reports;
